import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { ToolsActivity, UsageHistory } from "../../components/tools";

export const SingleTool = () => {
  const [toolDetails, setToolDetails] = useState({});
  const [companyDetails, setCompanyDetails] = useState({});
  const [reload, setReload] = useState(0);

  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    if (user) setCompanyDetails(user.company);
  }, [user]);

  const getCompanyWarehouseQuantity = (toolInventory = [], companyStoreId) => {
    const inventory = toolInventory.find((item) => item.storeId === companyStoreId);
    return inventory ? inventory.quantity : 0;
  };

  const reloadTools = () => setReload((prev) => prev + 1);

  return (
    <>
      <PageLayout>
        {/* header section */}
        <PageHeader
          title={`${toolDetails.name}` || "Tool Name"}
          subtitle={`Stock: ${getCompanyWarehouseQuantity(toolDetails.toolInventory, companyDetails.storeId)} / ${
            toolDetails.totalQuantity
          }`}
        />

        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <UsageHistory
                companyDetails={companyDetails}
                toolDetails={toolDetails}
                setToolDetails={setToolDetails}
                reloadData={reloadTools}
              />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <ToolsActivity companyDetails={companyDetails} reloadData={reload} />
            </Box>
          </Box>
        </Box>
      </PageLayout>
    </>
  );
};
